import React from 'react';

import { withAppState } from './../../../shared/containers/containerAppState'

import TitleBarWrapper from '../../../shared/titleBarWrapper'
import FirstTitle from '../../../shared/items/static/firstTitle'
import CarsCounterWrapper from './carsCounterWrapper'

import styles from './carsTitleBar.module.scss'

const CARS_BAR_TITLE = "Зимнее содержание"

const WinterUnitsTitleBar = () => {

  return (
    <TitleBarWrapper>
      <FirstTitle>
        {CARS_BAR_TITLE}
        <div className={styles.container_titleCounter}>
          <CarsCounterWrapper />
        </div>
      </FirstTitle>
    </TitleBarWrapper>
  )
}

export default withAppState(React.memo(WinterUnitsTitleBar))